import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import BreadCrumb from "../Controls/BreadCrumb";
import { Form, FormInput, FormActions } from "../Controls/Form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import API from "../../API";
import { refreshConnections } from "../../query/useConnections";

export default function Invite() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [guest, updateGuest] = useState({ FirstName: "", LastName: "", Email: "" });

  const onDone = async () => {
    try {
      const resp = await API.postAsync("/PostInvite", guest);
      if (resp && resp.ok) {
        const data = resp.jsonData || {};
        const id = data.ID ?? data.id;
        await refreshConnections(queryClient);
        if (id && id > 0) {
          toast.success("Invite sent");
          navigate("/connections", { state: { connectionModalId: id } });
          return;
        }
        toast.success("Invite sent");
        navigate("/connections");
        return;
      }
      const msg =
        (resp && resp.jsonData && (resp.jsonData.message || resp.jsonData.Message || resp.jsonData.msg)) ||
        "Invite failed";
      toast.error(msg);
    } catch (error) {
      const msg =
        error?.Message ||
        ((error?.response || {}).data || {}).msg ||
        error?.message ||
        "Invite failed";
      toast.error(msg);
      console.error(msg);
    }
  };

  return (
    <div>
      <BreadCrumb props={["Connections", "Invite Someone"]} />
      <h1>Invite a guest to join CareerMaster</h1>
      <Form object={guest} onUpdate={updateGuest}>
        <FormInput field="FirstName" label="First Name" required />
        <FormInput field="LastName" label="Last Name" required />
        <FormInput field="Email" label="Email" type="email" required />
        <FormActions onSaveAsync={async () => { await onDone(); }} />
      </Form>
    </div>
  );
}
